export const fillCfdiIssuer = (enterprise, validation) => {
  if (!enterprise) return

  validation.setFieldValue("ExpeditionPlace", enterprise?.invoice_address?.cp)
  validation.setFieldValue("Issuer.FiscalRegime", enterprise?.tax_regime)
  validation.setFieldValue("Issuer.Rfc", enterprise?.rfc)
  validation.setFieldValue("Issuer.Name", enterprise?.company_name)
}
